import './App.css';
import Logo from './logo.png'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={Logo} width={608} height={810} alt='фк мечта' ></img>
      </header>
    </div>
  );
}

export default App;
